import { create } from 'zustand';
import { createSearchFormSlice, type SearchFormSlice } from './slice';

// Create standalone search form store
const useSearchFormStore = create<SearchFormSlice>()(createSearchFormSlice);

/**
 * Performance-optimized selectors for the search form slice
 * Use these instead of accessing the store directly for better performance
 */
// Search form data selectors
export const useSearchFormData = () =>
	useSearchFormStore((state) => state.searchForm.formData);
// Search form actions selector
export const useSearchFormActions = () =>
	useSearchFormStore((state) => state.searchFormActions);
// Combined selectors for common usep cases
export const useSearchFormState = () =>
	useSearchFormStore((state) => state.searchForm);
export const useSearchForm = () =>
	useSearchFormStore((state) => ({
		...state.searchForm,
		actions: state.searchFormActions,
	}));

export const getSearchFormData = () =>
	useSearchFormStore.getState().searchForm.formData;
